module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter3"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block9"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TOC"
    }
  }, [_vm._v("Chapter 3")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p202"
    }
  }, [_c('span', {
    staticClass: "dropcap-rw"
  }, [_vm._v("T")]), _vm._v("he soft chords of her mother’s guitar woke Emma a few hours later. It felt like only minutes since she’d last closed her eyes, but now the sun was casting its glow across the tan bedsheet draped over her. The vaguely familiar sound of one of her new favorite country songs made her roll to her side to face Asher. He was sitting in her window seat, the guitar on his lap, his gaze somewhere out the window.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p203"
    }
  }, [_vm._v("The sight alone—him sitting there with nothing on but his jeans, strumming the strings of Clare’s prized possession, a Gibson guitar her mother had owned since she was fifteen—made Emma’s heart race.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p204"
    }
  }, [_vm._v("And the husky, deep sound of his voice singing the sexy, romantic lyrics to a song he’d teased her about liking the night before made him impossibly irresistible.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p205"
    }
  }, [_vm._v("Few people knew of his other talent—the ability to play anything just by hearing the song once. But he’d confessed his secret to her the first day they’d met almost ten years ago.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p206"
    }
  }, [_vm._v("He’d accidentally backed his truck into her snowboard leaning on the side of her tailgate in the local sporting goods store’s parking lot. Seeing who it was, she’d called him a dumb jock under her breath as she’d inspected the board. The Westmore brothers had a reputation in the town as local gods, and it had annoyed her that her equally impressive skills on a snowboard were always overshadowed by the Westmore boys’ accomplishments on ice.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p207"
    }
  }, [_vm._v("In his flushed, equally annoyed state, he’d used the confession about his guitar skills as a way to try to redeem himself in her eyes and convince her he was much more than everyone in town thought.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p208"
    }
  }, [_vm._v("It had worked. Without really knowing her, he’d hit a chord with her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p209"
    }
  }, [_vm._v("He’d also paid for a replacement board and insisted she owed him at least a coffee for the insult. Coffee had turned into lunch, then a walk in the park, then dinner at Dale’s Pizzeria on Main Street, and eight hours later, she knew enough about him to write a book.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p210"
    }
  }, [_vm._v("And she’d realized she’d been dead wrong about him being a dumb jock. He’d actually graduated high school head of his class, despite studying while on the road playing Major Junior League hockey, and while hockey was his main focus, he was arguably a better musician. At least at that point in his career.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p211"
    }
  }, [_vm._v("When the Westmores were hockey-obsessed kids, their mother had insisted that he and his brothers take at least one non-hockey-related extracurricular activity. Ash had picked guitar…and he had to work very little at it to be good.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p212"
    }
  }, [_vm._v("She smiled now, loving the sight and the sound of the twangy, off-tune instrument.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p213"
    }
  }, [_vm._v("Her mother would play the same guitar for her and her younger sister, Jess, every night before bed, telling them stories about her year in country heaven, playing the local bars and writing songs for some of Nashville’s finest stars. She’d get a dreamy, far-off look in her eyes whenever she spoke of those days, before she’d met their father, before she’d had them…and Emma had always felt a tug of heartache in her chest that her mother hadn’t realized her dream of becoming a country star back then.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p214"
    }
  }, [_vm._v("Clare’s encouragement had been part of Emma’s own driving force to succeed, to follow her dreams and not let anything stand in the way. Her mother had pushed her to keep trying, to get back up when she fell, and she’d been so proud of what Emma had accomplished with her snowboarding career.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p215"
    }
  }, [_vm._v("She wondered what her mom would think about her giving it up.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p216"
    }
  }, [_vm._v("She swallowed a lump in her throat as Ash glanced up at her and stopped playing. “Good morning.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p217"
    }
  }, [_vm._v("“Don’t stop,” she said, grabbing her blanket as she climbed out of bed. Wrapping it around her body, she went to sit next to him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p218"
    }
  }, [_vm._v("He turned slightly to face her and continued strumming, singing the lyrics in a smooth flawless tone that made shivers dance down her spine. His eyes met hers and her heart thundered in her chest.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p219"
    }
  }, [_vm._v("Damn, the guy may be a star athlete, but he missed another calling with music. He was certainly hot enough holding that guitar.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p220"
    }
  }, [_vm._v("He tore his gaze from hers as he finished the song and checked the clock on the bedside table. “I have to go,” he said, setting the guitar on the stand a second later.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p221"
    }
  }, [_vm._v("“What would happen if you didn’t?” she asked as he pulled her to her feet. She moved into his open arms, breathing in the scent of him, savoring the feel of his big, strong arms wrapped around her tiny frame as long as she could. The Devils’ next game against Colorado wasn’t until New Year’s Eve…sooner than usual, but still too long.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p222"
    }
  }, [_vm._v("He’d be playing on Christmas Eve in Phoenix, and she knew they would probably toast on New Year’s Eve through Skype. As they did most years…So why did the thought depress her so much more now?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p223"
    }
  }, [_vm._v("He kissed her forehead and didn’t answer the question he knew she really wasn’t expecting an answer to.")]), _vm._v(" "), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration3"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p224"
    }
  }, [_vm._v("*  *  *")])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p225"
    }
  }, [_vm._v("Knocking once on the Colorado team’s doctor’s office door, Asher entered the tiny room with the crammed desk and examination table. It was nine a.m. and no one else was around yet, but the Avalanche players would be arriving for early morning practice soon. His own team was scheduled for practice at noon, and he needed a pick-me-up before he could even entertain the thought of getting on the ice.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p226"
    }
  }, [_vm._v("The dip in temperature being back in his hometown that week had his knee all kinds of messed up. Jersey had yet to see snow, and the East Coast was enjoying unseasonably high temperatures for mid-November, for which he was grateful. The cold made his knee feel a million times worse.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p227"
    }
  }, [_vm._v("Fooling around with Emma the night before hadn’t been a great idea, either—though only his knee thought so. The rest of him was feeling great. He always did after spending time with her. That could be a problem if he let himself think about it for too long, so he pushed the thought aside. He had one thing to think about that day: beating his brother’s team and getting one step closer to his milestone game five nights from now in New Jersey, on his adopted home ice.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p228"
    }
  }, [_vm._v("At first he’d been disappointed when he hadn’t gotten drafted to play in Colorado with Ben. Every young player dreams of wearing their hometown colors someday, but the Devils had offered him a solid contract and a good place to cut his blades, and he’d been happy to re-sign with the team five years ago when his first seven-year contract had expired. He only had six months left on his current contract and hoped to renew once more. He wanted to finish his career where it started. They had no reason to trade him—he was one of their VIP players, and the team felt like family. He was getting older, though, and his body wasn’t bouncing back from injuries as fast as it used to…Still, he believed he was a strong asset to his team.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p229"
    }
  }, [_vm._v("Playing opposite Ben in Colorado twice a season was always exciting—for them and for the fans. The atmosphere in the stadium would be electric, and he knew the fans were happy for him and his success, even though he wore the opposing team’s colors.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p230"
    }
  }, [_vm._v("And that evening, one game away from his milestone, would be off the charts…if he could even stand up on his skates.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p231"
    }
  }, [_vm._v("“Hey, Seth, how are you?” he said, closing the office door behind him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p232"
    }
  }, [_vm._v("“Hey, man…I’m good. How’s the knee?” He frowned, noticing Asher’s slight limp.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p233"
    }
  }, [_vm._v("Mornings were by far the worst, after hours of rest…not that there’d been much the night before. An image of Emma’s perfect, tight little body straddling him flashed in his mind, and he shook his head. Nope, hadn’t exactly been resting.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p234"
    }
  }, [_vm._v("“Or should I even ask?” Seth continued. “I’m guessing you’re not here this early to shoot the shit.” A tightness was undeniable in his old high school friend’s voice, as he pushed his thick, dark-rimmed glasses higher on his nose.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p235"
    }
  }, [_vm._v("Seth had always been a wannabe athlete, watching from the sidelines. His severe asthma and poor eyesight made sports a challenge. Despite being a spirited player, he was always picked last for teams and had never excelled at individual competition, either, coming in last at track and field. By high school, he’d finally accepted his fate and had focused on studying hard to graduate with scholarships, going into sports medicine in college instead. Asher had always liked the guy, and he knew the Avalanche players were lucky to have Seth looking after them.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p236"
    }
  }, [_vm._v("“Sure I am,” he said. “After I get an injection…and possibly one for the road.” He climbed up onto the table and lifted the leg of his gray sweats. The knee was visibly swollen, and the inflammation was the main cause of the pain. A damaged ACL was torture, and unfortunately one of the most common injuries in the sport, besides concussions. He’d been skating on the damaged knee for almost a year and knew he had to take some time to let it heal, but not yet.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p237"
    }
  }, [_vm._v("Two more games.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p238"
    }
  }, [_vm._v("Seth moved closer to examine the knee. “Who have you been getting the injections from in Jersey?” He frowned, seeing the bruising at the various injection sites around the knee.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p239"
    }
  }, [_vm._v("Thank God he’d been able to keep Emma’s attention away from the knee the night before, otherwise he’d have caught some serious shit from her. He’d narrowly escaped a lecture about how self-medicating to dull the pain wasn’t solving the bigger problem. He knew that, and he didn’t feel good about the way he was handling things, but he just needed to hang on a little bit longer.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p240"
    }
  }, [_vm._v("Asher shrugged. “Just the team’s doctor.” And several walk-in clinic doctors just outside of New Jersey. Luckily the medical systems weren’t tied together, so no one doctor saw all the frequent cortisone injections he was getting. Or hell, maybe they just didn’t give a shit. The Devils had been close to a Stanley Cup win the season before, getting taken out in the second round by the Avalanche. Everyone was expecting one this year. Doping a player to ensure that it happened certainly wasn’t a new thing in sports.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p241"
    }
  }, [_vm._v("“Bullshit.” Seth called him out on the lie. “No one’s giving you this much.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p242"
    }
  }, [_vm._v("Asher’s mouth went dry. Lying to his buddy made him feel like an ass, especially when it had been Seth who had helped him that summer with enough injections to make it through training camp. With Seth’s help, Asher had been able to hide the extent of the injury from the Devils’ doctor long enough to get clearance to play that season. Their deal had been that he’d help him through camp, then Asher had to come clean with the team and take the necessary time off to let the ACL heal properly before it could be damaged beyond repair.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p243"
    }
  }, [_vm._v("Asher hadn’t lived up to his end of the bargain. “It was feeling better after camp, and it’s just been acting up again the last few weeks.” Man, the stack of lies kept piling up.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p244"
    }
  }, [_vm._v("Seth shook his head, but readied a needle. “I’m only doing this one last time, and only because tonight is game 999 and I know how bad you want this, man.” He tapped the needle and gave no warning as he hit the site next to Asher’s knee.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p245"
    }
  }, [_vm._v("“Jesus.” Asher winced slightly at the tiny prick on the sensitive skin, but almost immediately relief flowed into the joint as Seth removed some of the excess fluid building up around the injury. The draining of the knee was disgusting, and Asher had to look away as Seth retracted the needle.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p246"
    }
  }, [_vm._v("“Does the team know what a wimp you are about needles?” Seth asked, tossing it into a safe disposal unit.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p247"
    }
  }, [_vm._v("“It’s not the needle, man, it’s that disgusting shit you pull out with it that makes me gag.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p248"
    }
  }, [_vm._v("“That disgusting shit will keep coming back until you take care of yourself,” he said, taking a second needle and injecting the cortisone.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p249"
    }
  }, [_vm._v("“I will. Next week, I’ll take a much-needed vacation.” For now, this would get him through practice and the game that evening if he didn’t push too hard. Normally, he was all in, every game, but this one and the next, he planned to take his intensity down a notch.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p250"
    }
  }, [_vm._v("His one-thousandth career game was a big milestone, one not every player reached. Especially not so young. His brother’s award plaque on his mother’s fireplace mantel taunted him almost as much as it motivated him…the same way Ben’s Stanley Cup win did. His older brother was always just one step ahead all of the freaking time. Being born last, Asher’s need to catch up had only magnified over the years. This year, he would reach the milestone and lead his team to the cup. And he’d have accomplished both earlier in his career than Ben had.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p251"
    }
  }, [_vm._v("But one thing at a time…")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p252"
    }
  }, [_vm._v("“Thank you. I feel good as new.” He pulled the leg of his sweats back down, bending and straightening the leg several times.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p253"
    }
  }, [_vm._v("“You’re not, though,” Seth warned. “Not even close. You’ve been playing with this ACL damage for too long. I have no idea how you’re doing it or what kind of crap you’re taking to manage the pain, but I shouldn’t be helping you like this.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p254"
    }
  }, [_vm._v("“You’re a good man.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p255"
    }
  }, [_vm._v("“No.” Seth’s irritation was evident in his voice. “I’m a doctor who is going against my better judgment "), _c('i', [_vm._v("and")]), _vm._v(" I’m your friend. I care about your long-term career, not just these milestone moments. That’s why I mean it when I say no more, Ash. This is it.” He removed his plastic gloves, balled them, and tossed them toward a trash can less than two feet away. Missed. Sighing, he bent to pick them up and place them in the trash.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p256"
    }
  }, [_vm._v("Asher nodded as he slowly climbed down from the table. “No problem. This was all I needed, and I appreciate you helping me out. Again. I promise I’ll rest up after Tuesday’s night’s game. I’ll take all the recovery time I need then.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p257"
    }
  }, [_vm._v("Seth didn’t look convinced. “Okay, man. I really hope you do. Either way, I’m out.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p258"
    }
  }, [_vm._v("“Fair enough.” He understood and respected that. His friend had put his neck on the line enough.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p259"
    }
  }, [_vm._v("“Good luck out there tonight. If anyone’s going to beat my team, I’ll be less angry about it if it’s you.”")]), _vm._v(" "), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration4"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p260"
    }
  }, [_vm._v("*  *  *")])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p261"
    }
  }, [_vm._v("Emma shivered as she ran across the street to check her mailbox. November should not feel this cold. It happened every year—winter hit when no one was looking. She used to love the first signs of the winter season. Her muscles would spring to life at the dip in temperatures followed by early morning frost, and the anticipation of months ahead on the slopes had been like a drug-induced high.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p262"
    }
  }, [_vm._v("Things hadn’t felt like that for years. Now winter brought with it a sense of dread, a reminder of what she could no longer do.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p263"
    }
  }, [_vm._v("The snowboarding accident three days before she was set to leave for the Winter Olympics in Sochi had destroyed much more than her ability to compete. Her spirit had been crushed.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p264"
    }
  }, [_vm._v("When the Olympic committee had announced the new Slopestyle competition in that year’s games, she’d known it was her sport. The discipline was a mix of BMX and skateboarding crossing over onto the slopes. The course was made up of obstacles such as rails and jumps, and Emma had been stoked when she’d made the elite team of athletes to attempt the competition. The jumps and tricks were exhilarating and gave her a new sense of passion for her sport.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p265"
    }
  }, [_vm._v("Snowboarding had been as natural to her as walking, and she’d been excited about a new challenge.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p266"
    }
  }, [_vm._v("Then she’d gotten cocky.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p267"
    }
  }, [_vm._v("The weather had been mild for a week, and her coach had ordered a no-training day until the slopes were in better shape. But there was one stunt she’d yet to perfect: the double flat-down handrail. She struggled with picking up enough speed as she left the half-pipe on the course right before the obstacle, and she couldn’t do a double axel before landing without the extra height.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p268"
    }
  }, [_vm._v("She didn’t need the stunt. She could do the single with precision and ease. But she didn’t want to just final in the division. She’d wanted the gold medal around her neck. Again.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p269"
    }
  }, [_vm._v("Going out on the slopes that day was the worst decision she’d made in her life.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p270"
    }
  }, [_vm._v("She was moving too fast on the icy packed slope when she hit the first ramp. More speed didn’t help as she hit the half-pipe, and her landing was unsteady. She should have dropped, rolled away from the flat-down handrail, but at the speed she was cruising, she knew she could hit the stunt.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p271"
    }
  }, [_vm._v("Adrenaline soared through her as she did.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p272"
    }
  }, [_vm._v("Then pain replaced that sensation as the impact of the hard crash on the end of the rail broke her femur in her left leg and her right collarbone in two different places, and dislocated three disks in her spine.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p273"
    }
  }, [_vm._v("She’d missed the Olympics and had immediately lost all of her sponsors as soon as word of her accident spread. The look of disappointment on her coach’s face as he’d left the hospital room to join the rest of the U.S. team on the flight to Russia had made her wish for death. The deep, dark void dragging her spirits to unhealthy thoughts while being medicated to dull the aching in her entire body had nearly killed her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p274"
    }
  }, [_vm._v("To be so close to something she’d worked so hard and long for and to have it taken away when the goal was just within sight had been devastating.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p275"
    }
  }, [_vm._v("She hadn’t thought she’d recover from it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p276"
    }
  }, [_vm._v("If it hadn’t been for her family and Asher she might not have—though both had had very different ways of helping her through it. While Ash’s method had been to encourage healing and getting back out there, her father and sister had called it a new opportunity to move on with a real career. They’d never believed she’d make it as far as she had with snowboarding, and they’d almost acted validated when she’d gotten hurt. But they’d been there to help her through it, and in time, she’d realized they’d been right.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p277"
    }
  }, [_vm._v("A life in professional sports was uncertain, something she couldn’t build a future on. She thought of Asher and Ben—in their thirties, they were starting to wind down, and most players retired by forty—and while they’d never have to worry about money once they hung up their skates for the last time, what about a sense of purpose? Would they feel fulfilled living in the limelight of their past accomplishments? She wasn’t sure that was possible for men who possessed the drive and determination needed to be where they were.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p278"
    }
  }, [_vm._v("Emma had simply dealt with the heartbreak of retirement earlier in her career and had made some tough decisions. Now she was in a good place. She opened the mailbox and retrieved her mail, her heart nearly stopping when she saw the envelope on top.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p279"
    }
  }, [_vm._v("A letter from the University of Florida’s physical therapy doctorate program.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p280"
    }
  }, [_vm._v("No longer feeling the biting wind, she tore open the letter and skipped past the first cordial paragraph, searching for the word "), _c('i', [_vm._v("accepted")]), _vm._v(" or "), _c('i', [_vm._v("denied")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p281"
    }
  }, [_c('i', [_vm._v("We’d like to offer you enrollment in our winter semester starting January 10…")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p282"
    }
  }, [_vm._v("Wow. January 10. Only eight weeks away. She’d been hoping to enroll for the following fall semester, but could she be ready to move to Florida that quickly? Excitement rose in her chest, but she forced herself to think logically. She’d need to give notice at the clinic…but they were enthusiastic about her plans to pursue her PhD—they could benefit from a more skilled doctor in the field.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p283"
    }
  }, [_vm._v("Her sister would need to take over more responsibility in looking after their father, but this school and this program had been Jess’s idea, so she knew her sister would encourage her to accept the earlier start date.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p284"
    }
  }, [_vm._v("She bit her lip, clutching the letter as the wind nearly stole it from her hand. Her only real hesitancy came from thoughts of Asher. She hadn’t mentioned her plans to him yet, thinking she had months before the fall semester started…but she’d have to tell him soon if she was going to accept the January enrollment.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p285"
    }
  }, [_vm._v("She wasn’t sure how he’d take it. He was always supportive of her life choices, but she knew he still believed she should return to the slopes. He didn’t hide the fact that he thought she’d walked away too soon, too easily. And she couldn’t help but feel as though her moving on with a new passion and a new career was somehow disappointing to him. But maybe the idea of her being in Florida, closer to New Jersey, might appeal to him…")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p286"
    }
  }, [_vm._v("It certainly was a pro for her when she’d been deciding which schools to apply to—not that she was making a life-changing decision based on a guy who’d made it perfectly clear that she should expect nothing more than mind-blowing sex from him several times a year. Sigh. She’d been almost certain he’d been about to say the words she’d longed to hear.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p287"
    }
  }, [_vm._v("Her cell phone rang as she went inside, and her sister’s number lit the call display. “Hey, Jess,” she said, going into the kitchen, where she tucked the letter inside a physical therapy textbook. She’d been studying like crazy, reading through her undergraduate course textbooks and reviewing her notes, wanting to be ready for the program, should she be accepted.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p288"
    }
  }, [_vm._v("“Well? Did you hear anything yet?” Jess asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p289"
    }
  }, [_vm._v("Her sister’s timing was uncanny. It was like they shared a connection she’d expect twins to have, despite being two years apart in age. Her sister was the youngest and, unfortunately, the one with her life figured out.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p290"
    }
  }, [_vm._v("Emma hesitated.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p291"
    }
  }, [_vm._v("If she told Jess the truth, her sister would be there within minutes to help her pack her things, and she wasn’t sure she could make the January timeline work just yet. Though it was certainly tempting. “Um…I’m sure I will soon.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p292"
    }
  }, [_vm._v("“Have you checked the mail today?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p293"
    }
  }, [_vm._v("Obviously, her sister knew something she wasn’t saying. “Tell me you haven’t been harassing your professor friend at the university.” She knew letting Jess contact her friend from college to put in a good word for her had been a mistake. In fact, mentioning her interest in the doctoral program to her sister in the first place had been a mistake. Emma had been considering the program at the University of Colorado, but Jess had insisted that the program in Florida had a better sports medicine division. When Jess got her teeth into something, she was like a dog with a bone. Relentless and determined. Unfortunately, after researching their program, Emma had had to concede that her sister was right this time. Their sports therapy program especially appealed to her, and it was one of the top programs in the country.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p294"
    }
  }, [_vm._v("“Of course not,” Jess said now, sounding slightly offended, as if harassment wasn’t in her wheelhouse. “I just "), _c('i', [_vm._v("happened")]), _vm._v(" to talk to him the other day…”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p295"
    }
  }, [_vm._v("Right.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p296"
    }
  }, [_vm._v("“And he mentioned that the department was sending out their replies to applicants that week…and knowing that mail takes about three days from Florida to Colorado…Whatever, it’s simple deduction, Emma. Did you check your mail or not?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p297"
    }
  }, [_vm._v("If she continued lying, her sister would be there in three and a half minutes anyway wrestling the mailbox key from her, and Emma wouldn’t stand a chance against her sister’s taller, bigger frame. “Fine. Yes. I got the letter.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p298"
    }
  }, [_vm._v("“Okay, I’m in the car…”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p299"
    }
  }, [_vm._v("She heard the call switching to Bluetooth. Unbelievable.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p300"
    }
  }, [_vm._v("“Don’t open it until I get there.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p301"
    }
  }, [_vm._v("“What makes you think I haven’t opened it already?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p302"
    }
  }, [_vm._v("“Because you’re not excited or depressed, just your usual annoyingly casual self.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p303"
    }
  }, [_vm._v("Head journalist and reporter for the "), _c('i', [_vm._v("Glenwood Times")]), _vm._v(", Jess expected everyone to have a fire under their ass all the time the way she did. Chasing local stories that could be shaped into exciting, newsworthy fodder on a daily basis was the perfect career for her high-strung, type-A sister.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p304"
    }
  }, [_vm._v("Hell, to Jess, grocery shopping was a mission not to be taken lightly.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p305"
    }
  }, [_vm._v("Well, Emma had that fire and she was excited…she just approached big decisions a little more cautiously than Jess. And unfortunately, she couldn’t shake thoughts of Asher and what he’d think from her mind.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p306"
    }
  }, [_vm._v("“I opened it,” she said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p307"
    }
  }, [_vm._v("Silence.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p308"
    }
  }, [_vm._v("“Jess?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p309"
    }
  }, [_vm._v("“I’m holding my breath,” came her anxiety-filled whisper.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p310"
    }
  }, [_vm._v("She would regret this instantly, she just knew it. “I got in.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p311"
    }
  }, [_vm._v("The high-pitched squeal that followed had her immediately disconnecting the call. She couldn’t deal with Jess today. She loved her sister, but she was exhausting. Her input on Emma’s life after snowboarding was driving Emma mad. She knew Jess thought she was being helpful, but she was a little too much, too often. She’d practically filled out Emma’s application to attend the University of Colorado for her bachelor’s degree in physical therapy while Emma was still recovering in the hospital, and it had been Jess who’d encouraged her to attend school year-round, instead of taking a break during the summer months, to complete the degree a year early.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p312"
    }
  }, [_vm._v("Emma glanced at the time on her microwave. It was after two p.m. She’d taken the day off knowing that following a night with Asher, she’d need several naps before heading to Denver for Asher’s game. She wouldn’t see him before he played, and she might be able to steal a few minutes with him after the game, but that would be the extent of face-to-face contact for almost another seven weeks.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p313"
    }
  }, [_vm._v("New Year’s Eve, when he played in Denver again.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p314"
    }
  }, [_vm._v("Somehow she had to make that opportunity work to tell him how she felt. She refused to let another midnight roll over into another new year without telling him that she loved him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p315"
    }
  }, [_vm._v("But before then, she had to summon the courage to tell him about the University of Florida, because while she wasn’t ready to admit it to her sister just yet, she was ready to take the next step in her career, which meant leaving Glenwood Falls right after the holidays.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44ba91c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/s008-Chapter-003.vue
// module id = 84
// module chunks = 0